"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from "react";
import { Screenshot, useScreenshot } from "@/components/domain/screenshot";
import { usePointerCapability } from "@domainstack/ui/hooks";
import { Popover, PopoverContent, PopoverTrigger } from "@domainstack/ui/popover";
export function ScreenshotPopover(t0) {
  const $ = _c(30);
  const {
    domain,
    domainId,
    children,
    align,
    alignOffset,
    side,
    sideOffset
  } = t0;
  const [open, setOpen] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);
  const tapCount = useRef(0);
  const {
    isTouchDevice
  } = usePointerCapability();
  let t1;
  if ($[0] !== domain || $[1] !== domainId || $[2] !== hasOpened) {
    t1 = {
      domain,
      domainId,
      enabled: hasOpened
    };
    $[0] = domain;
    $[1] = domainId;
    $[2] = hasOpened;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const screenshot = useScreenshot(t1);
  let t2;
  if ($[4] !== isTouchDevice) {
    t2 = e => {
      if (isTouchDevice && tapCount.current === 0) {
        e.preventDefault();
        tapCount.current = 1;
        setOpen(true);
        setHasOpened(true);
      }
    };
    $[4] = isTouchDevice;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleInteraction = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = v => {
      setOpen(v);
      if (v) {
        setHasOpened(true);
      } else {
        tapCount.current = 0;
      }
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children || $[8] !== handleInteraction) {
    t4 = <PopoverTrigger nativeButton={false} openOnHover={true} delay={0} closeDelay={300} onClick={handleInteraction} render={children} />;
    $[7] = children;
    $[8] = handleInteraction;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex items-center gap-1.5"><div className="h-2 w-2 rounded-full bg-[#FF5F57]" /><div className="h-2 w-2 rounded-full bg-[#FEBC2E]" /><div className="h-2 w-2 rounded-full bg-[#28C840]" /></div>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== domain) {
    t6 = <div className="flex h-6 items-center gap-2 border-b border-zinc-200 bg-zinc-100 px-2 dark:border-zinc-800 dark:bg-zinc-900" aria-hidden={true}>{t5}<div className="flex h-3.5 flex-1 items-center rounded-sm bg-zinc-200 px-2 dark:bg-zinc-800"><span className="inline-block w-full truncate text-center text-[8px] text-zinc-500 dark:text-zinc-400">{domain}</span></div></div>;
    $[11] = domain;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== domain || $[14] !== screenshot.data || $[15] !== screenshot.isLoading) {
    t7 = <div className="bg-white dark:bg-zinc-950"><Screenshot domain={domain} data={screenshot.data} isLoading={screenshot.isLoading} /></div>;
    $[13] = domain;
    $[14] = screenshot.data;
    $[15] = screenshot.isLoading;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <div className="w-[360px] md:w-[420px]"><div className="block h-auto w-full overflow-hidden rounded-lg select-none">{t6}{t7}</div></div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== align || $[21] !== alignOffset || $[22] !== side || $[23] !== sideOffset || $[24] !== t8) {
    t9 = <PopoverContent className="w-auto rounded-lg bg-transparent p-0 shadow-xl" align={align} alignOffset={alignOffset} side={side} sideOffset={sideOffset}>{t8}</PopoverContent>;
    $[20] = align;
    $[21] = alignOffset;
    $[22] = side;
    $[23] = sideOffset;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== open || $[27] !== t4 || $[28] !== t9) {
    t10 = <Popover open={open} onOpenChange={t3}>{t4}{t9}</Popover>;
    $[26] = open;
    $[27] = t4;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
}